import { Icon } from '@99designs/common/components/Icon';
import { Tooltip } from '@99designs/common/components/Tooltip';
import { colors, typography } from '@99designs/common/core/settings';
import { Field as DefaultField } from 'common/components/Form';
import Card from 'projects/components/Card';
import React from 'react';

const HelpTooltip: React.SFC = ({ children }) => {
    const style = {
        fontSize: typography.fontSizes.root,
        color: colors.typography.softer,
    };

    const contents = <div style={{ maxWidth: 300, textAlign: 'center' }}>{children}</div>;

    return (
        <Tooltip tooltip={contents} position="up-center">
            <span style={style}>
                <Icon type={'question-mark-1'} variations={['offset-left']} />
            </span>
        </Tooltip>
    );
};

interface Props {
    id?: string;
    tooltip?: string;
    title: string;
    message?: string;
    required?: boolean;
    error?: string;
}

const Field: React.SFC<Props> = ({ id, title, message, tooltip, required, error, children }) => {
    const titleWithTooltip = (
        <span>
            {title}
            {required && '\u00A0'}
            {required && <span className="required">*</span>}
            {tooltip && '\u00A0'}
            {tooltip && <HelpTooltip>{tooltip}</HelpTooltip>}
        </span>
    );

    return (
        <Card id={id} variations={['field']}>
            <Card.Block>
                <DefaultField
                    errorMessage={error}
                    title={titleWithTooltip}
                    variations={['jumbo-title']}
                >
                    {message && <p className="card__message">{message}</p>}
                    {children}
                </DefaultField>
            </Card.Block>
        </Card>
    );
};

export default Field;
